import React, { useEffect } from 'react';
import { ActivityIndicator, Keyboard, Pressable, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';

export default function RemoteMacComposerNotice({ status }) {
  const { colors } = useTheme();
  const router = useRouter();
  const checking = status === 'checking';
  useEffect(() => { Keyboard.dismiss(); }, []);

  return <View style={[styles.card, { borderColor: colors.border_color_secondary, backgroundColor: colors.solid_color_block }]}>
    <View style={styles.heading}>
      {checking ? <ActivityIndicator size="small" color={colors.text_color_secondary} />
        : <Icon name="laptop" size={20} color={colors.text_color_secondary} />}
      <Text size="m" weight="medium" style={{ flex: 1 }} accessibilityLiveRegion="polite">
        {checking ? 'Connecting to your Mac…' : 'Reconnect your Mac'}
      </Text>
    </View>
    <Text size="s" color="secondary" style={{ lineHeight: 22 }}>
      {checking ? 'You can keep reading this chat while we check your Mac’s connection.'
        : 'Turn on your Mac and open Gab AI, or reconnect it in Remote to continue. You can still read this chat.'}
    </Text>
    <Pressable accessibilityRole="link" accessibilityLabel="Open Remote" onPress={() => router.push('/remote-projects')}
      style={({ pressed }) => [styles.link, { borderColor: colors.border_color_secondary, opacity: pressed ? 0.6 : 1 }]}>
      <Text size="s" weight="medium">Open Remote</Text>
      <Icon name="arrow-right" size={13} color={colors.text_color_primary} />
    </Pressable>
  </View>;
}

const styles = StyleSheet.create({
  card: { borderRadius: 18, borderWidth: 1, padding: 18, gap: 10, marginBottom: 12 },
  heading: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  link: { alignSelf: 'flex-start', minHeight: 44, flexDirection: 'row', alignItems: 'center', gap: 10,
    borderWidth: 1, borderRadius: 22, paddingHorizontal: 16, paddingVertical: 10 },
});
